<template>
  <div style="height: 100%; background: #F2F2F6">
         <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/' }">{{$t("base.index")}}</el-breadcrumb-item>
          <el-breadcrumb-item v-if="$route.params.type==1" :to="{ name: 'Factory' }">厂家列表</el-breadcrumb-item>
          <el-breadcrumb-item v-else :to="{ name: 'Producer' }">板商列表</el-breadcrumb-item>
          <el-breadcrumb-item v-if="$route.params.type==1" :to="{ name: 'EditFactory',params:{innerid:$route.params.related} }">编辑厂家</el-breadcrumb-item>
          <el-breadcrumb-item v-else :to="{ name: 'EditProducer',params:{innerid:$route.params.related} }">编辑板商</el-breadcrumb-item>
          <el-breadcrumb-item>协议生成</el-breadcrumb-item>
        </el-breadcrumb>
        <el-row style="padding:30px 30px 0;color:#666666;font-size:16px ">
          当前编辑{{ title }}<span></span>
        </el-row>
          <el-divider></el-divider>
          <el-row style="color:#666666;font-size: 14px;">
            <el-col :offset="1" :span="22">{{base.name}}</el-col>
          </el-row>
        <el-row style="padding:30px 30px 0;color:#666666;font-size:16px ">
          自定义协议创建说明<span></span>
        </el-row>
          <el-divider></el-divider>
        <el-row style="color:#666666;font-size: 13px;">
          <el-col :offset="1" :span="22">1.首次使用此功能，请先通过<el-link  :underline="false" style="font-size:12px;"  download
                href="../../static/file/协议对接模板.zip"
                type="primary">{{$t("base.tempDownload")}}</el-link>下载模板及说明文件，并仔细阅读其中的模板填写规则。</el-col>
          <el-col :offset="1" :span="22" >2.可选择在线编辑功能，或通过本地填写Excel上传生成，两种方式都可配置自定义协议。</el-col>
          <el-col :offset="1" :span="22">3.请勿修改模版文件中的sheet页数量和名称，并按模版规则填写。</el-col>
          <el-col :offset="1" :span="22">4.当修改协议，可使用在线编辑功能直接编辑后，快速重新生成，无需再次上传Excel。</el-col>
        </el-row>
        <el-row style="padding:30px 30px 0;color:#666666;font-size:16px ">
          本地文件上传<span></span>
        </el-row>
          <el-divider></el-divider>
    <el-row style="padding: 30px">
      <el-col :span="6">
        <el-upload
  class="upload-demo"
  ref="upload"
  drag
  action=""
  :multiple="false"
  :show-file-list="false"
  :auto-upload="false"
  accept=".xls,.xlsx"
  :on-change="excelUpload">
  <i class="el-icon-upload"></i>
  <div class="el-upload__text">将Excel文件拖到此处，或<em>点击上传</em></div>
</el-upload>
      </el-col>
    </el-row>
    <el-row style="padding:0px 30px 0;color:#666666;font-size:16px ">
          在线预览&编辑<span></span>
        </el-row>
          <el-divider></el-divider>
          <el-row>
            <el-button v-if="false" size="small" style="margin-left:20px" type="danger" @click="init()">在线表格初始化</el-button>
            <el-button size="small" type="primary" @click="build()">生成协议</el-button>
            <el-button size="small" type="success" @click="exportEcxel()">导出</el-button>
            <el-button size="small" type="info" @click="$router.back()">返回</el-button>
          </el-row>
          <div  v-loading="building"  element-loading-text="效验生成中..." id="gridctr" style="width:96%;overflow: auto;margin: 10px auto;"></div>

  </div>
</template>

<script>
import Vue from 'vue'
import temp from '../../../static/file/temp.json'
import { read, utils } from 'xlsx'
import validate from './validateProtocol'
var grid
export default {
  name: 'createRole',
  data () {
    return {
      building: false,
      base:{},
      title:this.$route.params.type==1?'厂家':'板商',
      protocolid:0
    }
  },
  mounted: function () {
    let customer = window.localStorage.getItem('customer')
    if (customer) {
      if(this.$route.params.related&&this.$route.params.type){
        
        Vue.axios
        .post(this.$route.params.type==1?'/factory/query':'/producer/query', {
          innerid: this.$route.params.related
        })
        .then((res) => {
          if (res.data.errcode == 0) {
            this.base = res.data.msgbody
          }
        })
        if(this.$route.params.innerid){
        Vue.axios
          .post(this.$route.params.type==1?'/factory/protocol/cust/query':'/producer/protocol/cust/query', {
            innerid: this.$route.params.innerid
          })
          .then((res) => {
            if (res.data.errcode == 0) {
              if (!grid) {
                x_spreadsheet.locale('zh-cn');
                grid = x_spreadsheet(document.getElementById('gridctr'),{showToolbar: false})
              }
              this.protocolid=res.data.msgbody.protocolid
              let table=JSON.parse(res.data.msgbody.original)
              table.forEach((sheet,index)=>{
                if(index>0){
                  if(Object.keys(sheet.rows).length>=100){
                    sheet.rows.len=Object.keys(sheet.rows).length+2
                  }
                }
              })
              grid.loadData(table)
            } else {
              this.$message({
                showClose: true,
                message: res.data.errmsg || this.$t("base.systemError"),
                type: 'error'
              })
            }
          })
       }
      }else{
        this.$message({
        message: '页面初始化失败，请重新进入',
        type: 'error'
      })
      }       
    } else {
      this.$message({
        message: this.$t('base.noSession'),
        type: 'warning'
      })
      this.$router.push({ name: 'Login' })
    }
  },
  destroyed: function () {
    grid=null
  },
  methods: {
    excelUpload (file, fileList) {
      this.$refs.upload.clearFiles()
      console.log(file)
      let reader = new FileReader()
      reader.onload = function (e) {
        const wb = XLSX.read(e.target.result)
        let d = stox(wb)
        if (!grid) {
          x_spreadsheet.locale('zh-cn');
          grid = x_spreadsheet(document.getElementById('gridctr'),{showToolbar: false})
        }
        d[0].rows.len=40
        console.log(d)
        grid.loadData(d)
      }
      reader.readAsArrayBuffer(file.raw)
    },
    init () {
      if (!grid) {
          x_spreadsheet.locale('zh-cn');
          grid = x_spreadsheet(document.getElementById('gridctr'),{showToolbar: false})
        }
        // d[0].rows.len=100
        grid.loadData(JSON.parse(JSON.stringify(temp)))
      
    },
    exportEcxel () {
      const da = grid.getData()
      var new_wb = xtos(da);
      XLSX.writeFile(new_wb, '协议导出.xlsx');
    },
    build () {
      if (this.building) {
        return
      }
      this.building = true
      try{
        if (grid) {
        let da = grid.getData()
        let res = validate(da)
        grid.loadData(da)
        if (res.error) {
        
          this.$message({
            message: res.error,
            type: 'error'
          })
        }else{
          this.$message({
            message: '效验通过，生成协议',
            type: 'success'
          })
          res.original=da
          let url=this.$route.params.type==1?'/factory/protocol/cust/add':'/producer/protocol/cust/add'
          if(this.$route.params.innerid){
            url=this.$route.params.type==1?'/factory/protocol/cust/edit':'/producer/protocol/cust/edit'
            res.innerid=this.$route.params.innerid
            res.protocolid=this.protocolid
          }
         
          res.factoryid=this.$route.params.related
          res.producerid=this.$route.params.related
          Vue.axios
          .post(url, res)
          .then((res) => {
            if (res.data.errcode == 0) {
              this.$message({
                showClose: true,
                message: res.data.errmsg || this.$t("base.saveSuccess"),
                type: 'success'
              })
            } else {
              this.$message({
                showClose: true,
                message: res.data.errmsg || this.$t("base.systemError"),
                type: 'error'
              })
            }
          })
        }

      } else {
        this.$message({
          message: '无文件数据',
          type: 'error'
        })
      }
      }catch(e){
        console.error(e)
        this.$message({
          message: '效验excel文件失败,请检查文件，请勿更改模板排版，并逐行填写',
          type: 'error'
        })
      }finally{
        this.building = false
      }

     
    },
    back () {
      this.$router.back()
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
.x-spreadsheet-sheet,
.x-spreadsheet-overlayer,
.x-spreadsheet-toolbar{
  width:100% !important;
  padding:0;
  max-height:700px;
}

.x-spreadsheet-scrollbar.vertical{
  height:700px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Protocol/Add.vue